export const langTxt: any = {
    us: {
        ask: 'Intelligent agent is here',
        collapse: 'Collapse',
    },
    cn: {
        ask: '您的智能助手在线中~',
        collapse: 'Collapse',
    },
    jp: {
        ask: 'ｽﾏｰﾄｴｰｼﾞｪﾝﾄです',
        collapse: 'Collapse',
    },
    de: {
        ask: 'Intelligenter Agent ist bereit.',
        collapse: 'Collapse',
    },
    fr: {
        ask: 'Agent intelligent présent.',
        collapse: 'Collapse',
    },
    kr: {
        ask: '스마트 에이전트 도착.',
        collapse: 'Collapse',
    },
    es: {
        ask: 'Agente inteligente activo.',
        collapse: 'Collapse',
    },
    it: {
        ask: 'Agente intelligente pronto.',
        collapse: 'Collapse',
    },
};
